// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-member-info-modal .modal__container{
    padding: var(--space-x3) 0 0 0;
    width: 500px;
}

.team-member-info-modal__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: var( --space-x2 ) ;
    width: 100%;
    border-top: 1px solid var(--new-line-color);
}

.team-member-info-modal__container .icon-ball {
    color: var( --white-color );
    font-size: calc( var( --space-x3 ) + var( --space ) );
    border-radius: 50%;
    padding: var( --space-quarter );
}

.team-member-info-modal__container img {
    border-radius: 50%;
    width: calc( var( --space-x3 ) + var( --space ) );;
    height: calc( var( --space-x3 ) + var( --space ) );;
}

.team-member-info-modal__container .baloa-names {
    color: var( --primary-dark-color );
    margin-top: var( --space-half );
}

.team-member-info-modal__container .baloa-username {
    color: var( --basic-gray-color );
    margin-top: var( --space-quarter );
}

.team-member-info-modal__container .baloa-table-column {
    color: var( --primary-dark-color );
    margin-bottom: var( --space-half-quarter );
}

.team-member-info-modal__info-column .baloa-username:last-of-type,
.team-member-info-modal__email .baloa-username:last-of-type {
    color: var( --primary-dark-color );
}

.team-member-info-modal__btns-action {
    display: flex;
    margin-top: var( --space );
    margin-bottom: var( --space-x2 ); 
}

.team-member-info-modal__btns-action .button {
    font-size: calc( var( --space-half-quarter ) + 1px );
    padding: var( --space-half ) calc( var( --space ) + var( --space-quarter ) );   
}

.team-member-info-modal__btns-action .button:first-of-type {
    margin-right: var( --space-quarter );    
}

.team-member-info-modal__btns-action .button:last-of-type {
    margin-left: var( --space-quarter );    
}

.team-member-info-modal__container .baloa-table-column,
.team-member-info-modal__email {
    width: 100%;
}

.team-member-info-modal__email {
    margin-top: var( --space-and-half );
    margin-bottom: var( --space-and-half );
}

.team-member-info-modal__info-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: var(--space);
}
.team-member-info-modal__info-column{
    width: 50%;
    align-items: center;
    justify-content: flex-start ;
}

.team-member-info-modal__info-column div:first-of-type,
.team-member-info-modal__email div:first-of-type {
    margin-bottom: var( --space-quarter );
    
}

.team-member-info-modal__btns-action .secondary-button {
    border: var( --space-eighth ) solid var( --error-color );
    color: var( --error-color );
}

.team-member-info-modal .column-tag{
    padding: 4px 6px;
    border-radius: 25px;
    color: var(--white-color);
    width: fit-content;
    margin-top: var(--space-quarter);
}

.team-member-info-modal .column-tag.registered{
    background: var(--new-green-color);
}

.team-member-info-modal .column-tag.no_registered{
    background: var(--basic-gray-color);
}

.team-member-info-modal .column-tag.pre_registered{
    background: var(--new-yellow-color);
}

.team-member-info-modal__message.baloa-username{
    color: var(--primary-very-dark-color);
    margin-top: 12px;
    align-items: center;
    display: flex;
}

.team-member-info-modal__icon-edit {
    cursor: pointer;
    width: 16px;
    height: 16px;
    margin-left: 8px;
    padding: 0px;
}

.team-member-info-modal__icon-edit path {
    fill: var( --new-green-color );
}

.team-member-info-modal__info-subtitle{
    display: flex;
    align-items: center;
}

.team-member-info-modal__message__link{
    color: var(--new-green-color);
    text-decoration: underline;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/team-member-info-modal/TeamMemberInfoModal.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,qDAAqD;IACrD,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,iDAAiD;IACjD,kDAAkD;AACtD;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,oDAAoD;IACpD,4EAA4E;AAChF;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,wBAAwB;AAC5B;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;;IAEI,qCAAqC;;AAEzC;;AAEA;IACI,wDAAwD;IACxD,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,eAAe;AACnB","sourcesContent":[".team-member-info-modal .modal__container{\n    padding: var(--space-x3) 0 0 0;\n    width: 500px;\n}\n\n.team-member-info-modal__container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: var( --space-x2 ) ;\n    width: 100%;\n    border-top: 1px solid var(--new-line-color);\n}\n\n.team-member-info-modal__container .icon-ball {\n    color: var( --white-color );\n    font-size: calc( var( --space-x3 ) + var( --space ) );\n    border-radius: 50%;\n    padding: var( --space-quarter );\n}\n\n.team-member-info-modal__container img {\n    border-radius: 50%;\n    width: calc( var( --space-x3 ) + var( --space ) );;\n    height: calc( var( --space-x3 ) + var( --space ) );;\n}\n\n.team-member-info-modal__container .baloa-names {\n    color: var( --primary-dark-color );\n    margin-top: var( --space-half );\n}\n\n.team-member-info-modal__container .baloa-username {\n    color: var( --basic-gray-color );\n    margin-top: var( --space-quarter );\n}\n\n.team-member-info-modal__container .baloa-table-column {\n    color: var( --primary-dark-color );\n    margin-bottom: var( --space-half-quarter );\n}\n\n.team-member-info-modal__info-column .baloa-username:last-of-type,\n.team-member-info-modal__email .baloa-username:last-of-type {\n    color: var( --primary-dark-color );\n}\n\n.team-member-info-modal__btns-action {\n    display: flex;\n    margin-top: var( --space );\n    margin-bottom: var( --space-x2 ); \n}\n\n.team-member-info-modal__btns-action .button {\n    font-size: calc( var( --space-half-quarter ) + 1px );\n    padding: var( --space-half ) calc( var( --space ) + var( --space-quarter ) );   \n}\n\n.team-member-info-modal__btns-action .button:first-of-type {\n    margin-right: var( --space-quarter );    \n}\n\n.team-member-info-modal__btns-action .button:last-of-type {\n    margin-left: var( --space-quarter );    \n}\n\n.team-member-info-modal__container .baloa-table-column,\n.team-member-info-modal__email {\n    width: 100%;\n}\n\n.team-member-info-modal__email {\n    margin-top: var( --space-and-half );\n    margin-bottom: var( --space-and-half );\n}\n\n.team-member-info-modal__info-row {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    margin-top: var(--space);\n}\n.team-member-info-modal__info-column{\n    width: 50%;\n    align-items: center;\n    justify-content: flex-start ;\n}\n\n.team-member-info-modal__info-column div:first-of-type,\n.team-member-info-modal__email div:first-of-type {\n    margin-bottom: var( --space-quarter );\n    \n}\n\n.team-member-info-modal__btns-action .secondary-button {\n    border: var( --space-eighth ) solid var( --error-color );\n    color: var( --error-color );\n}\n\n.team-member-info-modal .column-tag{\n    padding: 4px 6px;\n    border-radius: 25px;\n    color: var(--white-color);\n    width: fit-content;\n    margin-top: var(--space-quarter);\n}\n\n.team-member-info-modal .column-tag.registered{\n    background: var(--new-green-color);\n}\n\n.team-member-info-modal .column-tag.no_registered{\n    background: var(--basic-gray-color);\n}\n\n.team-member-info-modal .column-tag.pre_registered{\n    background: var(--new-yellow-color);\n}\n\n.team-member-info-modal__message.baloa-username{\n    color: var(--primary-very-dark-color);\n    margin-top: 12px;\n    align-items: center;\n    display: flex;\n}\n\n.team-member-info-modal__icon-edit {\n    cursor: pointer;\n    width: 16px;\n    height: 16px;\n    margin-left: 8px;\n    padding: 0px;\n}\n\n.team-member-info-modal__icon-edit path {\n    fill: var( --new-green-color );\n}\n\n.team-member-info-modal__info-subtitle{\n    display: flex;\n    align-items: center;\n}\n\n.team-member-info-modal__message__link{\n    color: var(--new-green-color);\n    text-decoration: underline;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
